var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDotsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 91,
    viewBox: "0 0 93 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 86",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#847B7B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 46.5,
    cy: 10.5,
    r: 10.5,
    fill: "#847B7B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 82.5,
    cy: 10.5,
    r: 10.5,
    fill: "#847B7B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 10.5,
    cy: 45.5,
    r: 10.5,
    fill: "#847B7B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 46.5,
    cy: 45.5,
    r: 10.5,
    fill: "#847B7B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 82.5,
    cy: 45.5,
    r: 10.5,
    fill: "#847B7B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 10.5,
    cy: 80.5,
    r: 10.5,
    fill: "#847B7B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 46.5,
    cy: 80.5,
    r: 10.5,
    fill: "#847B7B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 82.5,
    cy: 80.5,
    r: 10.5,
    fill: "#847B7B"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsGrey);
export default __webpack_public_path__ + "static/media/dots_grey.1425c468cbe5175c891d7f97a50ecdc7.svg";
export { ForwardRef as ReactComponent };